import { AxiosInstance } from "axios";
import { httpDelete, httpPost, HttpEvent, HttpEventCallbacks } from "@/events/eventsDomain";
import { ShareTypeRequest } from "./shareClassesDomain";

export type ShareTypeApiClient = {
  createShareType: (request: ShareTypeRequest, params: HttpEventCallbacks<void>) => HttpEvent<void>;

  editShareType: (
    request: ShareTypeRequest,
    shareTypeId: number,
    params: HttpEventCallbacks<void>,
  ) => HttpEvent<void>;

  deleteShareType: (
    shareTypeId: number,
    orgNo: string,
    params: HttpEventCallbacks<void>,
  ) => HttpEvent<void>;
};

export const shareTypeApiClient: ShareTypeApiClient = {
  createShareType: (request, params) =>
    httpPost({ url: `/sharetype/new`, data: request, ...params }),

  editShareType: (request, shareTypeId, params) =>
    httpPost({ url: `/sharetype/edit/${shareTypeId}`, data: request, ...params }),

  deleteShareType: (shareTypeId, orgNo, params) =>
    httpDelete({ url: `/sharetype/${shareTypeId}/${orgNo}`, ...params }),
};

export class ShareTypeHttpClient {
  constructor(private readonly http: AxiosInstance) {}

  async editShareType(request: ShareTypeRequest, shareTypeId: number): Promise<void> {
    await this.http.post(`/sharetype/edit/${shareTypeId}`, request);
  }
}
